import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import React, { useEffect } from "react";
import { useState } from "react";
const flow_HS = require( '../../../Assets/Images/flowScoreIcons/H-S.png')
const flow_HM = require( '../../../Assets/Images/flowScoreIcons/H-M.png')
const flow_HST = require( '../../../Assets/Images/flowScoreIcons/H-ST.png')
const flow_MH = require( '../../../Assets/Images/flowScoreIcons/M-H.png')
const flow_MS = require( '../../../Assets/Images/flowScoreIcons/M-S.png')
const flow_MST = require( '../../../Assets/Images/flowScoreIcons/M-ST.png')
const flow_SH= require( '../../../Assets/Images/flowScoreIcons/S-H.png')
const flow_SM = require( '../../../Assets/Images/flowScoreIcons/S-M.png')
const flow_SST = require( '../../../Assets/Images/flowScoreIcons/S-ST.png')
const flow_STH = require( '../../../Assets/Images/flowScoreIcons/ST-H.png')
const flow_STM = require( '../../../Assets/Images/flowScoreIcons/ST-M.png')
const flow_STS = require( '../../../Assets/Images/flowScoreIcons/ST-S.png')

const HeartIcon = require("../../../Assets/Images/Heart-Icon.png");
const SoulIcon = require('../../../Assets/Images/SOUL.png')
const StrengthIcon = require('../../../Assets/Images/STRENGTH.png')
const MindIcon = require('../../../Assets/Images/MIND.png')
const HeartToSoul = require("../../../Assets/Images/HeartToSoul.png");
const HeartToSoul2 = require("../../../Assets/Images/HeartToSoul2.png");
const LatoRegular = require("../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");


Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    borderRadius: "5px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    justifyContent: "left",
    fontFamily: "Lato",
    marginTop: "20px",
  },
  topSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-between",
    width: "100%",
  },
  coverTitle: {
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "30px",
    color: "#426B88",
  },
  contentContainer: {
    textAlign: "left",
    maxWidth: "800px",
    marginTop: "40px",
  },
  highlightText: {
    fontWeight: "700",
    fontSize: "14px",
    lineHeight: "22px",
    color: "#34495E",
    marginBottom: "5px",
  },
  paragraph: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    textAlign: "justify",
    marginBottom: "12px",
  },
  coverImage: {
    width: "50%",
    maxWidth: "220px",
  },
  textContent: {
    marginLeft: "20px",
  },
  pointsSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginVertical: "15px",
  },
  pointGroup: {
    width: "48%",
  },
  SubTitle: {
    fontWeight: "700",
    fontSize: "18px",
    lineHeight: "30px",
    color: "#426B88",
  },
  pointsContainer: {
    width: "100%",
    textAlign: "center",
    marginLeft: "20px",
    marginTop: "10px",
  },
  pointsHeader: {
    fontWeight: "700",
    fontSize: "12px",
    color: "#245775",
    lineHeight: "18px",
    fontFamily: "Lato",
    marginBottom: "8px",
    textAlign: "left",
  },
  pointsSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    width: "100%",
  },
  pointGroup: {
    width: "45%",
    textAlign: "left",
  },
  pointText: {
    fontWeight: "400",
    fontSize: "12px",
    color: "#245775",
    lineHeight: "18px",
    marginBottom: "4px",
  },
  imgContainer: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 10,
  },

  imageWrapper: {
    flexDirection: "row",
    alignItems: "center",
  },
  connectorWrapper: {
    position: "relative",
    width: 70,
    alignItems: "center",
    justifyContent: "center",
  },
  connector: {
    height: 2,
    backgroundColor: "#245775",
    width: "100%",
  },
  arrow: {
    position: "absolute",
    fontSize: 50,
    fontWeight: "light",
    top: -32,
    color: "#245775",
  },
  text: {
    textAlign: 'left',
    fontSize: '13px',
    color: '#245775',
    marginLeft: '65px'
  },
  labelNames: {
    flexDirection: "row",
    width: '100%',
    marginTop: '16px',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '70px',
    position: 'relative'
  },
  labelPercentages: {
    flexDirection: "row",
    width: '100%',
    marginTop: '4px',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '70px',
    position: 'absolute',
    top: '10px'
  },
  imageLabel: {
    fontSize: '13px',
    color: '#245775',
    marginLeft: '50px'
  }, 
  scoreValue: {
    fontSize: '16px',
    color: '#245775',
    marginLeft: '50px'
  }, 
  logolabels: {
    position: 'absolute', 
    left: '10%',
    bottom: '0', 
    fontSize: '13px',
    color: '#245775',
  }
});

const  QuadrantFlowPage2 = ({ apiData }) => {
  const [highestStarter, setHighestStarter] = useState('')
  const [mostSelecTedStarter, setMostSelecTedStarter] = useState('')
  const [secondMostSelecTedStarter, setSecondMostSelecTedStarter] = useState('')
  const [snapshotResult, setSnapshotResults] = useState([])
  const [starterLabel, setStarterLabel] = useState([])
  
  const [variablsMapArray, setVariableMapArray] = useState()
  const [scoreRanking, setScoreRanking] = useState([])
    

  const leadershipPairs = [
    { round1: "col_round1_m", round2: "col_round2_m" },
    { round1: "strat_round1_m", round2: "strat_round2_m" },
    { round1: "per_round1_m", round2: "per_round2_m" },
    { round1: "vis_round1_m", round2: "vis_round2_m" }
  ]

  const pairs = [
    { round1: "heart_round1_m", round2: "heart_round2_m" },
    { round1: "soul_round1_m", round2: "soul_round2_m" },
    { round1: "str_round1_m", round2: "str_round2_m" },
    { round1: "mind_round1_m", round2: "mind_round2_m" }
  ];

  const variableMap = apiData?.variables?.reduce((acc, el) => {
    acc[el.variable] = el.score;
    return acc;
  }, {});
  useEffect(() => {
    if (variableMap) {
      setVariableMapArray(variableMap);
    }
    console.log("apiData", apiData)
  }, [apiData]);

  useEffect(() => {
    let highestScore = -Infinity;
    let highestVariable = "";
    let results = [];
    let labelsArray = [];
    
    if (variablsMapArray) {
      console.log(variablsMapArray);
      const heart_r1_m = variablsMapArray["heart_round1_m"] || 0;
      const soul_r1_m = variablsMapArray["soul_round1_m"] || 0;
      const mind_r1_m = variablsMapArray["mind_round1_m"] || 0;
      const strength_r1_m = variablsMapArray["str_round1_m"] || 0;
    
      const heart_r2_m = variablsMapArray["heart_round2_m"] || 0;
      const soul_r2_m = variablsMapArray["soul_round2_m"] || 0;
      const mind_r2_m = variablsMapArray["mind_round2_m"] || 0;
      const strength_r2_m = variablsMapArray["str_round2_m"] || 0;
    
      const heart_r1_l = variablsMapArray["heart_round1_l"] || 0;
      const soul_r1_l = variablsMapArray["soul_round1_l"] || 0;
      const mind_r1_l = variablsMapArray["mind_round1_l"] || 0;
      const strength_r1_l = variablsMapArray["str_round1_l"] || 0;
    
      const heart_r2_l = variablsMapArray["heart_round2_l"] || 0;
      const soul_r2_l = variablsMapArray["soul_round2_l"] || 0;
      const mind_r2_l = variablsMapArray["mind_round2_l"] || 0;
      const strength_r2_l = variablsMapArray["str_round2_l"] || 0;
    
      const heart_highest = Math.max(heart_r1_m, heart_r2_m, heart_r1_l, heart_r2_l);
      const mind_highest = Math.max(mind_r1_m, mind_r2_m, mind_r1_l, mind_r2_l);
      const soul_highest = Math.max(soul_r1_m, soul_r2_m, soul_r1_l, soul_r2_l);
      const strength_highest = Math.max(strength_r1_m, strength_r2_m, strength_r1_l, strength_r2_l);

      console.log("Heart Highest = " + heart_highest + "\nMind Highest = " + mind_highest + "\nSoul Highest = " + soul_highest + "\nStrength Highest = " + strength_highest);
      // let testingVarsM2 = [heart_r2 + heart_r1_m, soul_r2 + soul_round1_m, mind_r2 + mind_round1_m, strength_r2 + strength_round1_m];
      let testingVarsM2Pair = [{"name": "heart", "score": heart_highest},{"name": "soul", "score": soul_highest},{"name": "mind", "score": mind_highest}, {"name": "strength", "score": strength_highest}];
      console.log("testingVarsM2Pair",testingVarsM2Pair);
    
      highestVariable = testingVarsM2Pair.reduce((max, current) => 
        current.score > max.score ? current : max, { name: "", score: -Infinity }
      );
    
    
      let most_score = Math.max(heart_r1_m,soul_r1_m,mind_r1_m,strength_r1_m)
      let second_most_score = Math.max(heart_r2_m,soul_r2_m,mind_r2_m,strength_r2_m) / 2
      let least_score = Math.max(heart_r1_l,soul_r1_l,mind_r1_l,strength_r1_l)
      let second_least_score = Math.max(heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l) / 2
    
      console.log("heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l",heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l)
      if ( least_score >= second_least_score ) {
        least_score = ( second_least_score - 1 )
      }
    
      const total = most_score + second_most_score + least_score + second_least_score;
    
      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score/ total) * 100 
    
      console.log("scores-",most_score,second_most_score,least_score,second_least_score)
      console.log("scores-per",most_per,second_most_per,least_score,second_least_per)
    
      
      let labels = testingVarsM2Pair.map(item => item.name);
    
      const labels_arr = ["heart", "soul", "mind", "strength"];
    
      const mostValues = [heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m];
      const secondMostValues = [heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m];
      const leastValues = [heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l];
      const secondLeastValues = [heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l];
    
      const most_score_label = Math.max(...mostValues);
      const second_most_score_label = Math.max(...secondMostValues);
      const least_score_label = Math.max(...leastValues);
      const second_least_score_label = Math.max(...secondLeastValues);
    
      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];
    
      const most_label = getLabel(mostValues, most_score_label);
      const second_most_label = getLabel(secondMostValues, second_most_score_label);
      const least_label = getLabel(leastValues, least_score_label);
      const second_least_label = getLabel(secondLeastValues, second_least_score_label);
    
      console.log(most_label , 'most_label')
      const getPercentageOrder = ( label ) => {
        if ( label == most_label?.toLowerCase() ) {
          return most_per;
        }
        if ( label == second_most_label?.toLowerCase() ) {
          return second_most_per;
        }
        if ( label == least_label?.toLowerCase() ) {
          return least_per;
        }
        if ( label == second_least_label?.toLowerCase() ) {
          return second_least_per;
        }
    
        return 0
      }
    
      console.log("scores- starter",most_score,second_most_score,least_score,second_least_score)
      console.log("scores-per-starter",most_per,second_most_per,least_score,second_least_per)
    
      // order should be most > second most > least > second least
      // results = [getPercentageOrder("mind"), getPercentageOrder("soul"), getPercentageOrder("strength"), getPercentageOrder("heart")] // label order = 'mind', 'soul', 'strength', 'heart'
      results = [getPercentageOrder("strength"), getPercentageOrder("heart"), getPercentageOrder("soul"), getPercentageOrder("mind")] // label order = 'mind', 'soul', 'strength', 'heart'
         
      // labelsArray = [...labelsArray, ...labels];
      // labelsArray = [least_label, second_least_label, second_most_label, most_label];
      labelsArray = ['mind', 'soul', 'strength', 'heart'];

      const RankedScores = [
        { name: "Heart", value: heart_highest },
        { name: "Mind", value: mind_highest },
        { name: "Soul", value: soul_highest },
        { name: "Strength", value: strength_highest }
      ];
      
      RankedScores.sort((a, b) => b.value - a.value);

      console.log(RankedScores)

      setScoreRanking(RankedScores)
    
      console.log('highestVariable', highestVariable)
      console.log("pie chart results", results);
      console.log("pie chart labelsArray", labelsArray);
    
      setHighestStarter(most_label);
      // setStarterScore(most_per);
      setSnapshotResults(results);
      setStarterLabel(labelsArray);
      getMostAndSecondMostVaribale(apiData)
    }
    
  }, [variablsMapArray]);

  const getMostAndSecondMostVaribale = () => {
    if (apiData?.variables?.length > 0) {
      const extractCoreVariable = (variable) =>
        variable?.split("_")[0];
      
      const highestRound1Variable = pairs
      ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round1))
      ?.filter(Boolean)
        ?.reduce((highest, current) => (current?.score > highest?.score ? current : highest), { score: -Infinity });

      const highestRound2Variable = pairs
        ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round2))
        ?.filter(Boolean)
        ?.reduce((highest, current) => (current?.score > highest?.score ? current : highest), { score: -Infinity });

      const coreRound1 = extractCoreVariable(highestRound1Variable?.variable);
      const coreRound2 = extractCoreVariable(highestRound2Variable?.variable);

      if (coreRound1 === coreRound2) {
        const secondHighestRound1Variable = pairs
          ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round1))
          ?.filter(Boolean)
          ?.sort((a, b) => b?.score - a?.score)
          ?.find((v) => v?.variable !== highestRound1Variable?.variable);

        setMostSelecTedStarter(highestRound1Variable?.variable || null);
        setSecondMostSelecTedStarter(secondHighestRound1Variable?.variable || null);
      } else {
        setMostSelecTedStarter(highestRound1Variable?.variable || null);
        setSecondMostSelecTedStarter(highestRound2Variable?.variable || null);
      }
      
      console.log(
        highestRound1Variable?.variable,
        highestRound2Variable?.variable,
        "highest"
      );
    }
  }

  const getFlowImage = () => {
    const images = {
      HS: flow_HS,
      HM: flow_HM,
      HST: flow_HST,
      MH: flow_MH,
      MS: flow_MS,
      MST: flow_MST,
      SH: flow_SH,
      SM: flow_SM,
      SST: flow_SST,
      STH: flow_STH,
      STM: flow_STM,
      STS: flow_STS,
    };
    const mapStarter = (starter) => {
      if (starter?.includes("str")) return "ST";
      return starter?.split("_")[0][0]?.toUpperCase();
    };

    const key = `${mapStarter(mostSelecTedStarter)}${mapStarter(secondMostSelecTedStarter)}`;
    return images[key?.toUpperCase()] || HeartToSoul;
  };
  

  const getFlowHead = () => {

    const flowMapping = {
      HS: "HEART TO SOUL",
      HM: "HEART TO MIND",
      HST: "HEART TO STRENGTH",
      MH: "MIND TO HEART",
      MS: "MIND TO SOUL",
      MST: "MIND TO STRENGTH",
      SH: "SOUL TO HEART",
      SM: "SOUL TO MIND",
      SST: "SOUL TO STRENGTH",
      STH: "STRENGTH TO HEART",
      STM: "STRENGTH TO MIND",
      STS: "STRENGTH TO SOUL",
    };


    const mapStarter = (starter) => {
      if (starter?.includes("str")) return "ST";
      return starter?.split("_")[0][0]?.toUpperCase();
    };

    const key = `${mapStarter(mostSelecTedStarter)}${mapStarter(secondMostSelecTedStarter)}`;
    const flowText = flowMapping[key] || "";
    return flowText;
  };

  const sectionFlowContent = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": `This type of person is grounded in feelings and meaning, valuing inner experiences and simply "being" over outward actions and achievements.`,
      "HEART TO MIND": "The Heart-to-Mind person feels first and thinks second. They start by caring, then add understanding to what’s already unfolding. Once they feel grounded, they begin to strategize. Though much of this process happens within, they always bring it back to relationships, where they can openly explore and refine their ideas.",
      "HEART TO STRENGTH": "The Heart-to-Strength person is fueled by emotional energy and a focus on action. They’re naturally driven by their feelings, wants, and needs, which motivate them to get things done.",
      "MIND TO HEART": "The Mind-to-Heart shift moves from logic to emotional connection, from head to heart.",
      "MIND TO SOUL": "People on the Mind-to-Soul path start with a clear plan and gradually seek deeper meaning, aiming to fit their ideas into a bigger, more meaningful picture.",
      "MIND TO STRENGTH": "People moving from Mind to Strength blend clear thinking with action. They’re the “think smarter, work harder” type, constantly tweaking their strategies to get better results.",
      "SOUL TO HEART": "Soul-to-Heart individuals prioritize presence, relational depth, and meaningful connections. With an innate ability to connect emotionally, they inspire trust and loyalty through their genuine, authentic nature. They navigate life thoughtfully, seeing beyond the surface.",
      "SOUL TO MIND": "These people begin with depth, meaning, and vision, creating ideas to bring their insights to life. They organize and structure their inner world, and if they need a new structure, they’ll invent it.",
      "SOUL TO STRENGTH": "Soul-to-Strength individuals quickly turn deep insights into action. They skip long planning phases, bringing the soul's depth straight into real-world impact.",
      "STRENGTH TO HEART": "Strength-to-Heart individuals dive into their missions with enthusiasm and passion, often bringing a welcoming attitude that quickly draws others in.",
      "STRENGTH TO MIND": "Strength-to-Mind individuals are fueled by action and a constant urge to make things better, always asking, “How can this improve?” This relentless drive for progress helps them advance quickly and find success.",
      "STRENGTH TO SOUL": "Strength-to-Soul individuals are dynamic visionaries who seek deeper meaning in their work, beyond just hitting goals.",
    };
  
    return contentMap[flowText] || "";
  };

  const flowTagline = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Feels good. But why?",
      "HEART TO MIND": "Feels good; I need to understand.",
      "HEART TO STRENGTH": "Feels good. Let’s go!",
      "MIND TO HEART": "Makes sense, who do I need? ",
      "MIND TO SOUL": "Makes sense, but why?",
      "MIND TO STRENGTH": "Makes sense; let’s go!",
      "SOUL TO HEART": "This is meaningful; let’s feel it.",
      "SOUL TO MIND": "This is meaningful; let’s design it.",
      "SOUL TO STRENGTH": "This is meaningful; let’s do something.",
      "STRENGTH TO HEART": "I’m doing this. Who’s in?",
      "STRENGTH TO MIND": "I’m doing this. How can it be better?",
      "STRENGTH TO SOUL": "I’m doing this, but why?",
    };
  
    return contentMap[flowText] || "";
  }

  const paraOne = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Heart-to-Soul individuals are guided by identity, values, and purpose. Rather than leading from the front, they create environments where life, love, and leadership can flourish naturally.",
      "HEART TO MIND": "This personality combines emotional connection with intellectual insight, creating a style that’s both compassionate and strategically strong.",
      "HEART TO STRENGTH": "For them, shifting from heart to strength means moving from simply “being” to actively “doing”—from experiencing and connecting to making things happen in a tangible, practical way.",
      "SOUL TO MIND": "However, their carefully crafted plans can sometimes be hard to put into practice because they’re based on big ideas and philosophy.",
      "MIND TO HEART": "These individuals, especially if relationally focused, prefer thoughtful and inclusive approaches over taking control. They need a deep understanding before they can fully invest or invite others in.",
      "MIND TO SOUL": "They commit to projects that match both their logical thinking and personal values, making their work both effective and fulfilling.",
      "MIND TO STRENGTH": "Focused on practical information and efficiency, they may sometimes overlook creativity, curiosity, or others’ needs.",
      "SOUL TO HEART": "However, they may struggle in environments that value speed, competition, and strategy over depth and authenticity.",
      "SOUL TO STRENGTH": "Even without strong strategic or relational backing, their drive and commitment often lead to impressive, unexpected results.",
      "STRENGTH TO HEART": "They’re natural motivators, using confidence, directness, and genuine empathy to kick-start projects and keep them going through emotional connection.",
      "STRENGTH TO MIND": "With a sharp focus on strategy and results, they sometimes overlook the emotional or cultural side of things, leaning toward efficiency over deeper relationships or cultural awareness. While they excel at getting things done, they may miss the nuances that create a more connected, balanced environment.",
      "STRENGTH TO SOUL": "They aim for their efforts to carry real significance, aligning personal values with professional goals. This means balancing practical actions with bigger visions to make their ideas a reality.",
    };

    return contentMap[flowText] || "";
  }

  const paraTwo = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Often seen as poets or creatives, they focus on soulful, intangible influence rather than conventional, straightforward strategies.",
      "HEART TO MIND": "",
      "HEART TO STRENGTH": "",
      "SOUL TO MIND": "",
      "MIND TO HEART": "Their clear thinking often brings calm to those seeking direction. Once they have a solid plan, they’re ready to welcome others on board.",
      "MIND TO SOUL": "However, they may have many ideas and insights without taking much action, which can make them appear insightful but hard to pin down.",
      "MIND TO STRENGTH": "Mind-to-Strength individuals are direct, preferring to explain or show their ideas clearly, making them easy to understand.",
      "SOUL TO HEART": "",
      "SOUL TO STRENGTH": "",
      "STRENGTH TO HEART": "Their strong drive builds initial connections, but these relationships can be tested if goals or plans change. If others aren’t aligned with their direction, they may be left behind.",
      "STRENGTH TO MIND": "",
      "STRENGTH TO SOUL": "Their high standards and shift toward purpose-driven goals can sometimes confuse or distance teammates used to simpler, more direct tasks. But despite these challenges, Strength-to-Soul people inspire others by showing how work can be both successful and deeply meaningful.",
    };

    return contentMap[flowText] || "";
  }

  const ArchtypeOne = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Deep Connector",
      "HEART TO MIND": "Collaborative Planner",
      "HEART TO STRENGTH": "Motivational Trailblazer",
      "SOUL TO MIND": "Purpose-Driven Innovator",
      "MIND TO HEART": "Strategic Connector",
      "MIND TO SOUL": "Philosophical Thinker",
      "MIND TO STRENGTH": "Continuous Improver",
      "SOUL TO HEART": "Authentic Guide",
      "SOUL TO STRENGTH": "Impactful Creator",
      "STRENGTH TO HEART": "Trusted Champion",
      "STRENGTH TO MIND": "Proactive Planner",
      "STRENGTH TO SOUL": "Genuine Influencer",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeTwo = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Authentic Sage",
      "HEART TO MIND": "Empathetic Guide",
      "HEART TO STRENGTH": "Passionate Doer",
      "SOUL TO MIND": "Visionary Architect",
      "MIND TO HEART": "Supportive Advisor",
      "MIND TO SOUL": "Insightful Innovator",
      "MIND TO STRENGTH": "Quick Problem-Solver",
      "SOUL TO HEART": "Compassionate Mentor",
      "SOUL TO STRENGTH": "Change Catalyst",
      "STRENGTH TO HEART": "Passionate Pioneer",
      "STRENGTH TO MIND": "Resourceful Thinker",
      "STRENGTH TO SOUL": "Resourceful Sage",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeThree = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Qualitative Advocate",
      "HEART TO MIND": "Culture Builder",
      "HEART TO STRENGTH": "Team Energizer",
      "SOUL TO MIND": "Thoughtful Communicator",
      "MIND TO HEART": "Compassionate Guide",
      "MIND TO SOUL": "Purpose-Driven Leader",
      "MIND TO STRENGTH": "Analytical Achiever",
      "SOUL TO HEART": "Relational Builder",
      "SOUL TO STRENGTH": "Driven Innovator",
      "STRENGTH TO HEART": "Community Builder",
      "STRENGTH TO MIND": "Considerate Driver",
      "STRENGTH TO SOUL": "Practical Mentor",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeFour = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Impractical Feeler",
      "HEART TO MIND": "Passive Strategist",
      "HEART TO STRENGTH": "Impulsive Drivers",
      "SOUL TO MIND": "Detached Idealist",
      "MIND TO HEART": "Oversensitive Analyst",
      "MIND TO SOUL": "Elusive Partner",
      "MIND TO STRENGTH": "Over-Analyzer",
      "SOUL TO HEART": "Disengaged Feeler",
      "SOUL TO STRENGTH": "Lone Wolf",
      "STRENGTH TO HEART": "Impulsive Reactor",
      "STRENGTH TO MIND": "Cold Pragmatist",
      "STRENGTH TO SOUL": "Detached Warrior",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeFive = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Complicated Connector",
      "HEART TO MIND": "Avoidant Decision-Maker",
      "HEART TO STRENGTH": "Short-sighted Steamroller",
      "SOUL TO MIND": "Big-Idea Drifter",
      "MIND TO HEART": "Burdened Planner",
      "MIND TO SOUL": "Idealistic Drifter",
      "MIND TO STRENGTH": "Lone Ranger",
      "SOUL TO HEART": "Over-absorbed Empath",
      "SOUL TO STRENGTH": "Isolated Visionary",
      "STRENGTH TO HEART": "Erratic Enthusiast",
      "STRENGTH TO MIND": "Stubborn Individualist",
      "STRENGTH TO SOUL": "Forceful Idealist",
    };

    return contentMap[flowText] || "";
  }
  const ArchtypeSix = (flowText) => {
    const contentMap = {
      "HEART TO SOUL": "Idealistic Dreamer",
      "HEART TO MIND": "Over-functioning Caretaker",
      "HEART TO STRENGTH": "Emotional Time-bomb",
      "SOUL TO MIND": "Cold Philosopher",
      "MIND TO HEART": "Reluctant Engager",
      "MIND TO SOUL": "Quiet Idealist",
      "MIND TO STRENGTH": "Rigid Enforcer",
      "SOUL TO HEART": "Low-Assertive Idealist",
      "SOUL TO STRENGTH": "Idealistic Pioneer",
      "STRENGTH TO HEART": "Coercive Connector",
      "STRENGTH TO MIND": "Relentless Taskmaster",
      "STRENGTH TO SOUL": "Pessimistic Dreamer",
    };

    return contentMap[flowText] || "";
  }

  const imagesMap = {
    Soul: { icon: SoulIcon, label: "Soul" },
    Heart: { icon: HeartIcon, label: "Heart" },
    Mind: { icon: MindIcon, label: "Mind" },
    Strength: { icon: StrengthIcon, label: "Strength" },
  };
  const sortedScores = scoreRanking.sort((a, b) => b.value - a.value);

  const sortedImages = sortedScores.map(item => imagesMap[item.name]);
  const baseSize = 120;
  const sizeDecrement = 30;
  const imageSizes = sortedImages.map((_, index) => baseSize - index * sizeDecrement); 
  
  return (
    <View style={styles.coverSection}>
      <View style={styles.topSection}>
        <Image src={getFlowImage()} style={styles.coverImage} />
        <view>
          <View style={styles.textContent}>
            <Text style={styles.coverTitle}>YOU FLOW FROM {getFlowHead()}</Text>
            <Text style={styles.SubTitle}>{flowTagline(getFlowHead())}</Text>
          </View>
          <View style={styles.pointsContainer}>
            <Text style={styles.pointsHeader}>Possible Archetypes</Text>
            <View style={styles.pointsSection}>
              <View style={styles.pointGroup}>
                <Text style={styles.pointText}>• {ArchtypeOne(getFlowHead())}</Text>
                <Text style={styles.pointText}>• {ArchtypeTwo(getFlowHead())}</Text>
                <Text style={styles.pointText}>• {ArchtypeThree(getFlowHead())}</Text>
              </View>
              <View style={styles.pointGroup}>
                <Text style={styles.pointText}>• {ArchtypeFour(getFlowHead())}</Text>
                <Text style={styles.pointText}>• {ArchtypeFive(getFlowHead())}</Text>
                <Text style={styles.pointText}>• {ArchtypeSix(getFlowHead())}</Text>
              </View>
            </View>
          </View>
        </view>
      </View>

      <View style={styles.contentContainer}>
        <Text style={styles.paragraph}>
        {sectionFlowContent(getFlowHead())}
        </Text>
        <Text style={styles.paragraph}>
          {paraOne(getFlowHead())}
        </Text>
        <Text style={styles.paragraph}>
          {paraTwo(getFlowHead())}
        </Text>
      </View>
      <Text style={styles.text}>Start</Text>
      <View style={styles.imgContainer}>
        {sortedImages.map((item, index) => (
          <View key={index} style={styles.imageWrapper}>
            <Image src={item.icon} style={{ width: imageSizes[index], height: imageSizes[index] }} />
            {/* <Text style={styles.logolabels}>{item.label}</Text> */}
            {index < sortedImages.length - 1 && (
              <View style={styles.connectorWrapper}>
                <View style={styles.connector} />
                <Text style={styles.arrow}>&gt;</Text>
              </View>
            )}
          </View>
        ))}
      </View>
      <View style={styles.labelNames}>
        {sortedImages.map((item, index) => (<Text style={styles.imageLabel}>{item.label}</Text> ))}
        <View style={styles.labelPercentages}>
        {sortedImages.map((item, index) => {
          const score = sortedScores[index].value; 
          return (
            <Text style={styles.scoreValue}>{score}%</Text>
          )
        })}
        </View>
      </View>
        
    </View>
  );
};

export default QuadrantFlowPage2;
